/**
 * Idioma de fechas de las tablas (decisión F6): «hoy 12:40», «ayer 17:30»,
 * absoluto corto («26 jul») — y relativo («hace 16 días») SOLO en casas
 * paradas: la distancia es la noticia.
 */
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const hm = (d: Date) => `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
export function diasDesde(iso: string, ahora = new Date()): number {
  return Math.floor((ahora.getTime() - new Date(iso).getTime()) / 86_400_000);
}
const medianoche = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
/** Días NATURALES entre dos fechas (anteayer por la tarde no es «ayer»). */
export function diasNaturales(iso: string, ahora = new Date()): number {
  return Math.round((medianoche(ahora) - medianoche(new Date(iso))) / 86_400_000);
}
/** «26 jul» · «26 jul 2026» — el MISMO mes abreviado que la tabla, para que
 *  una pantalla no diga «sep» arriba y «sept» abajo (lo de Intl es-ES). */
export const fechaCorta = (iso: string): string => { const d = new Date(iso); return `${d.getDate()} ${MES[d.getMonth()]}`; };
export const fechaLarga = (iso: string): string => `${fechaCorta(iso)} ${new Date(iso).getFullYear()}`;
export function fechaTabla(iso: string | null, parada: boolean, ahora = new Date()): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (parada) return `hace ${diasDesde(iso, ahora)} días`;
  const dias = diasNaturales(iso, ahora);
  if (dias === 0) return `hoy ${hm(d)}`;
  if (dias === 1) return `ayer ${hm(d)}`;
  return `${d.getDate()} ${MES[d.getMonth()]}`;
}
